export const COMPLETION_CRITERIA = [
  {
    key: 'seen',
    label: 'Vu en rendez-vous',
    check: (user, freelance) => freelance?.seen === true,
  },
  {
    key: 'title',
    label: 'Titre de fiche renseigné',
    check: (user, freelance) => !!freelance?.title,
  },
  {
    key: 'summary',
    label: 'Description courte renseignée',
    check: (user, freelance) => !!freelance?.summary,
  },
  {
    key: 'experiences',
    label: 'Au moins une mission renseignée',
    check: (user, freelance) => (freelance?.experiences?.length ?? 0) >= 1,
  },
  {
    key: 'master_skills',
    label: 'Au moins une spécialité renseignée',
    check: (user, freelance) => (freelance?.master_skills?.length ?? 0) >= 1,
  },
  {
    key: 'expertises',
    label: 'Au moins une compétence "Niveau confirmé" renseignée',
    check: (user, freelance) => (freelance?.expertises?.length ?? 0) >= 1,
  },
  {
    key: 'secteurs',
    label: 'Au moins un secteur renseigné',
    check: (user, freelance) => (freelance?.secteurs?.length ?? 0) >= 1,
  },
]

export function getCompletionChecklist(user, freelance) {
  return COMPLETION_CRITERIA.map(({key, label, check}) => ({
    key,
    label,
    valid: !!check(user, freelance),
  }))
}

export function canOfferCompletion(user, freelance) {
  if (user?.complete) {
    return false
  }

  return getCompletionChecklist(user, freelance).every((item) => item.valid)
}
